import {IAdTagResponce} from "@pages/Root/services/api/ads/ad-model-definitions.ts";
import { RoutePrefetchQueryOptions } from '../routes/types.ts';
import { API_URL, DEFAULT_CKEY, getInitializedMomentFetcher } from '@moment/net/fetch-contstants.ts';

export const generateFetchAdQuery = (options?: RoutePrefetchQueryOptions) => (brandGroupId?: string, utmSource: string= 'no source') => {
    return async () => {
        if (!brandGroupId) {
            console.warn(`no brand group found. throwing!`)
            throw new Error('no brand group supplied to generateFetchAdQuery')
        }

        const momentFetcher = await getInitializedMomentFetcher();
        const logger = options?.logger || undefined
        const key = JSON.stringify({
            brandGroupId,
            utmSource,
        })

        logger?.log(`generateFetchAdQuery - prefetching ad related items - brandGroupId=${brandGroupId}, utmSource=${utmSource}`)

        const url = `${API_URL}/wp/v1/brandgroup/${brandGroupId}/adtags?ckey=${DEFAULT_CKEY}&param=utm_source&value=${utmSource}`;
        const res = await momentFetcher.fetch(url, options);
        logger?.log(`generateFetchAdQuery - hit\n${url}\nstatus=${res.status}`)
        const output:IAdTagResponce = await res.json();

        return output satisfies IAdTagResponce
    };
};
